const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const parseResponse = async (response) => {
  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    try {
      const body = await response.json();
      message = body?.detail || body?.message || message;
    } catch (_e) {
      // ignore
    }
    throw new Error(message);
  }
  return response.json();
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  return parseResponse(response);
};

export const fetchPlatformUsageSummary = () => request('/api/platform/usage-summary');

export const fetchApiClients = () => request('/api/platform/clients');

export const createApiClient = (payload) =>
  request('/api/platform/clients', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const rotateApiClientKey = (clientId) =>
  request(`/api/platform/clients/${encodeURIComponent(clientId)}/rotate-key`, {
    method: 'POST',
  });

export const revokeApiClient = (clientId) =>
  request(`/api/platform/clients/${encodeURIComponent(clientId)}/revoke`, {
    method: 'POST',
  });

export const fetchWebhooks = () => request('/api/platform/webhooks');

export const createWebhook = (payload) =>
  request('/api/platform/webhooks', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const testWebhook = (webhookId) =>
  request(`/api/platform/webhooks/${encodeURIComponent(webhookId)}/test`, {
    method: 'POST',
  });

export const disableWebhook = (webhookId) =>
  request(`/api/platform/webhooks/${encodeURIComponent(webhookId)}/disable`, {
    method: 'POST',
  });

export const fetchWebhookDeliveries = (webhookId = null) => {
  const suffix = webhookId ? `?webhook_id=${encodeURIComponent(webhookId)}` : '';
  return request(`/api/platform/webhook-deliveries${suffix}`);
};

export const fetchIntegrations = () => request('/api/platform/integrations');

export const createIntegration = (payload) =>
  request('/api/platform/integrations', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const activateIntegration = (integrationId) =>
  request(`/api/platform/integrations/${encodeURIComponent(integrationId)}/activate`, {
    method: 'POST',
  });

export const disableIntegration = (integrationId) =>
  request(`/api/platform/integrations/${encodeURIComponent(integrationId)}/disable`, {
    method: 'POST',
  });
